export const PRODUCT_NAME = 'HAi BigQuery';
export const TITLE_PRODUCT_NAME = ` | ${PRODUCT_NAME}`;

export const ROLE_LIST = {
  root: {
    code: 'SYSTEM_DEVELOPER',
    name: '系統開發人員',
    set: true
  },
  admin: {
    code: 'SYSTEM_ADMIN',
    name: '系統管理員',
    set: true
  },
  editor: {
    code: 'SYSTEM_USER',
    name: '一般使用者',
    set: true
  },
  viewer: {
    code: 'SYSTEM_VIEWER',
    name: '檢視者',
    set: false
  },
}

// localstorage
export const TOKEN = 'token';
export const SESSION_CREATE_TIME = 'createTime';

export const POSITION = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: 'center'
}
